/**
 * SHA1 (RFC 3174) legacy hash function.
 * @module
 * @deprecated
 */
import { SHA1 as SHA1n, sha1 as sha1n } from "./legacy.js";
/** @deprecated Use import from `noble/hashes/legacy` module */
export const SHA1 = SHA1n;
/** @deprecated Use import from `noble/hashes/legacy` module */
export const sha1 = sha1n;
//# sourceMappingURL=sha1.js.map